export class ExaDocumento {

	
	idDocumento: number;
	nomeFileDocumento: string;
	stato: ExaDocumentoStato=ExaDocumentoStato.caricato;
	
	constructor(idDocumento?: number,
		nomeFileDocumento?: string
	) {
		if(idDocumento)
		{
			this.idDocumento=idDocumento;
		}
		if(nomeFileDocumento)
		{
			this.nomeFileDocumento=nomeFileDocumento;
		}
	}

}



export enum ExaDocumentoStato {
	caricato = 0,
	uploading = 1,
	error = 2,
	temporaneo=3,
}



// WEBPACK FOOTER //
// ./src/app/exa/exa-file/exa-document.ts